import { __UserData } from './register';

export interface __Answer {
    items: __AnswerItem[];
    access_token?: string;
    created_at: string;
    modified_at: string;
    state: __AnswerStatus;
    form: __FormDetail;
    id: number;
    publish: number;
    questionerOffline?: boolean;
    end_date?: string;
    answerer_info?: __AnswererInfo[];
    lat?: number;
    lng?: number;
}
export interface __AnswererInfo {
    column: number;
    id: number;
    row: number;
    value: string;
}

export interface __ReportDetail {
    tags: __Tags[];
    items?: __ReportQuestion[];
    indicators: {
        indicator__id: number;
        indicator__title: string;
        value: any;
    }[];
    created_at: string;
    modified_at: string;
    state: __AnswerStatus;
    publish_type: number;
    answer_parameters: { id: number; value: string; form_parameter: { title: string } }[];
    user_ip?: string;
    source: string;
    id: number;
}

export interface __AnswerItem {
    answer?: number;
    id: number;
    value?: string;
    question: __Question;
    question_items?: __QuestionItems[];
    answer_files?: __FileAttachment[];
    created_at?: string;
    questionerOffline?: boolean;
}
export interface __ReportQuestion {
    id: number;
    value: string | number;
    question: __Question;
    question_items: __QuestionItems[];
    created_at?: string;
}

export enum __AnswerStatus {
    complete = 1,
    incomplete = 2,
}

export interface __Question {
    title: string;
    id: number;
    order: number;
    description?: string;
    image_file?: __FileAttachment;
    video?: string;
    input_type: __QuestionTypes;
    validations?: __QuestionValidations[];
    is_required?: boolean;
    is_unique?: boolean;
    logic_action?: __QuestionLogicAction;
    logics: __QuestionLogic[];
    items?: __QuestionItems[];
    data_list?: __ContentItems;
    is_hidden?: boolean;
    children: __Question[];
    parent: __Question;
    pipelinecontainer_set?: __PipelineType[];
    // variables = models.ManyToManyField(QuestionVariable, blank=True)
    // settings = models.ManyToManyField(QuestionSetting, blank=True)
    // calculations = models.ManyToManyField(Calculation, blank=True)
}
export interface __PipelineType {
    id: number;
    pipeline_action?: __QuestionLogicAction;
    pipeline_jump_to?: number;
    pipeline_set?: __QuestionLogic[];
    type?: __LogicalType;
}

export enum __LogicalType {
    question = 1,
    context,
}

export interface __QuestionItems {
    id: number;
    title: string;
    payload: number;
    image_file?: __FileAttachment;
    question?: __Question;
    order?: number;
    value?: string | number;
    is_hidden?: boolean;
    archive?: boolean;
}
export interface __FileAttachment {
    completed_at?: string;
    created_at: string;
    extension: string;
    filename: string;
    offset: number;
    status: __FileAttachmentStatusEnum;
    type: __FileAttachmentTypeEnum;
    alt?: string;
    id: number | string;
    name: string;
    file: string;
    workspace: number;
    size: number;
}

export enum __FileAttachmentStatusEnum {
    incomplete = 1,
    complete = 2,
}

export enum __FileAttachmentTypeEnum {
    image = 1,
    video = 2,
    file = 3,
    audio = 4,
}

export interface __QuestionLogic {
    operation: __QuestionLogicOperator;
    answer_of: number;
    value: string[];
    datalist_column_number?: number;
    indicator?: number;
    question_items?: number[];
}

export enum __QuestionTypes {
    // EQUAL NOT EQUAL : All -  12

    // Compare : 11,14,16,19

    // has answer, no answer : All, =>  ( no next)

    pictureSelective = 1, //Dropdown :__QuestionItems(TITLE,ID)
    mobileNumber = 2, //Text
    phoneNumber = 3, //Text
    twoOptions = 4, //Dropdown : __QuestionItems(TITLE,ID)
    selective = 5, //Dropdown : __QuestionItems(TITLE,ID)
    dropDown = 6, //Dropdown : __QuestionItems(TITLE,ID)
    priority = 7,
    website = 8, //Utility inputRL
    // boolean = 9,
    simple = 10, //Text
    number = 11, //inputNumber
    camera = 12,
    scale = 13, // inputNumber
    email = 14, //Text
    voice = 15,
    rate = 16, //inputNumber
    date = 17, //Datepicker
    file = 18,
    nps = 19, //inputNumber
    emoji = 20,
    matrix = 21,
    static = 22,
}
export interface __ContentItems {
    id: number;
    title: string;
    contents?: {
        value: string;
        id: number;
    }[];
}
export interface __FormSection {
    id: number;
    title: string;
    bg_image_file: __FileAttachment;
    order: number;
    questions: __Question[];
    section_logics: __QuestionLogic[];
    logic_action?: __QuestionLogicAction;
    is_hidden?: boolean;
}

export enum __FormShowTypes {
    single = 1,
    multiple = 2,
}
export interface __FormDetail {
    id: number;
    title: string;
    description?: string;
    workspace: __WorkSpace;
    sections: __FormSection[];
    creator?: __UserData;
    first_page_description?: string;
    first_page_title: string;
    last_page_description?: string;
    last_page_title: string;
    ask_gps: boolean;
    auto_save: boolean;
    reset_sec_time: number;
    show_type: __FormShowTypes;
    lang: __Language;
    direction: __TextDirection;
    start_button: string;
    end_button: string;
    next_button: string;
    previous_button: string;
    wait_message: string;
    logo_first_page_file?: __FileAttachment;
    first_page_bg_file?: __FileAttachment;
    logo_last_page_file?: __FileAttachment;
    last_page_bg_file?: __FileAttachment;
    answer_color?: string;
    footer_color?: string;
    question_color?: string;
    background_color?: string;
    button_label_color?: string;
    background_image_file?: __FileAttachment;
    is_public?: boolean;
    uuid: string;
    hide_start_page: boolean;
    hide_end_page: boolean;
    password_title?: string;
    logo_first_page_size: __ImageSize;
    logo_last_page_size: __ImageSize;
    end_page_changed: boolean;
    has_password: boolean;
    subscription?: __Subscription;
    modified_at: string;
    hide_slp_footer?: boolean;
    question_counter?: boolean;
    indicators?: __IndicatorType[];
}

export interface __Subscription {
    id: number;
    title: string;
    color: string;
    icon: string;
    price: number | null;
    description: string[];
    duration: number;
    default: boolean;
    duration_type: __SusbscriptionType;
    auto_email_publish: boolean;
    auto_sms_publish: boolean;
    create_indicator: boolean;
    create_parameter: boolean;
    create_theme: boolean;
    email_publish: number;
    export_excel: boolean;
    iframe_publish: number;
    indicator_filter: boolean;
    kiosk_publish: number;
    link_publish: number;
    logical_relation: boolean;
    parameter_filter: boolean;
    question_filter: boolean;
    question_types: __QuestionTypes[];
    questioner_count: number;
    questioner_publish: number;
    questioner_publish_budget: number;
    quick_publish: number;
    sms_publish: number;
    tag_filter: boolean;
    theme_count: number;
    user_per_workspace: number;
    update_main_pages: boolean;
    using_template: boolean;
    visual_report: boolean;
    payment_link?: string;
    created_email_publish: number;
    created_forms_count: number;
    created_iframe_publish: number;
    created_kiosk_publish: number;
    created_link_publish: number;
    created_questioner_count: number;
    created_questioner_publish: number;
    created_sms_publish_count: number;
    workspace_count: number;
    hide_slp_footer: boolean;
    has_footer: boolean;
    has_footer_content: boolean;
}

export enum __SusbscriptionType {
    MONTHLY = 3,
    YEARLY = 4,
}

export interface __PrevFormDetail {
    first_page_bg_file?: __FileAttachment;
    background_image_file?: __FileAttachment;
    background_color?: string;
    logo_first_page_size?: __ImageSize;
    first_page_title: string;
    first_page_description?: string;
    start_button: string;
    lang: __Language;
    expire_date?: string;
    hide_start_page: boolean;
    has_password: boolean;
    logo_first_page_file?: __FileAttachment;
    title: string;
    button_label_color?: string;
    password_title?: string;
    hide_slp_footer?: boolean;
    ask_gps?: boolean;
    direction: __TextDirection;
}

export interface __FormDetailParametersType {
    title: string;
    is_unique: boolean;
    value: string;
    id?: number;
}
export interface __IndicatorType {
    id: number;
    title: string;
    questions: __IndicatorQuestions[];
}
export enum __PublishStatus {
    active = 1,
    inActive = 2,
    offline = 3,
}
export enum __QuestionLogicAction {
    and = 1,
    or = 2,
}
export enum __QuestionLogicOperator {
    bigger = 1,
    lower = 2,
    biggerEQ = 3,
    lowerEQ = 4,
    equal = 5,
    notEqual = 6,
    hasAnswer = 7,
    noAnswer = 8,
    hasValue = 9,
    noValue = 10,
}

export interface __IndicatorQuestions {
    question: number;
    items: __IndicatorItems[];
}
export interface __IndicatorItems {
    id: number;
    indicator: __IndicatorType;
    indicator_operator: __IndicatorOperator;
    indicator_value: number;
    item?: __QuestionItems;
    question_value?: string;
}

export enum __IndicatorOperator {
    add = 1,
    subtract = 2,
    multiply = 3,
    divide = 4,
}

export enum __Language {
    en = 1,
    fa,
}

export enum __TextDirection {
    ltr = 1,
    rtl = 2,
}

export enum __QuestionValidationTypes {
    length = 'length',
    minLength = 'minLength',
    maxLength = 'maxLength',
    description = 'description',
    required = 'required',
    multiline = 'multiline',
    defaultValue = 'defaultValue',
    max = 'max',
    min = 'min',
    maxEqual = 'maxEqual',
    minEqual = 'minEqual',
    maxScore = 'maxScore',
    iconScore = 'iconScore',
    startTitle = 'startTitle',
    endTitle = 'endTitle',
    middleTitle = 'middleTitle',
    startDate = 'startDate',
    endDate = 'endDate',
    dateBase = 'dateBase',
    autoSend = 'autoSend',
    sendType = 'sendType',
    smsText = 'smsText',
    options = 'options',
    orientation = 'orientation',
    selective = 'selective',
    pictureSize = 'pictureSize',
    randomItems = 'randomItems',
    capture = 'capture',
    fileType = 'fileType',
    fileMaxSize = 'fileMaxSize',
    multiFileSelect = 'multiFileSelect',
    maxEmoji = 'maxEmoji',
    emojiTitleShow = 'emojiTitleShow',
    matrixMultiSelect = 'matrixMultiSelect',
    maxTime = 'maxTime',
}

export interface __QuestionValidations {
    title: string;
    value?: string | number;
}

export interface __Publish {
    complete_answers?: number;
    form: __FormDetail;
    id: number;
    title: string;
    created_at: string;
    quota?: number;
}
export interface __KioskPublishType {
    id: number;
    title: string;
    created_at: string;
    form: __FormDetail;
    publish: number;
}

export enum __PublishType {
    link = 1,
    iframe,
    popup,
    email,
    sms,
    kiosk,
    questioner,
    qrcode,
    slp,
}
export interface __ViewApi {
    form: __PrevFormDetail;
    view_id?: string;
}

export interface __IconBadge {
    icon: string;
    color: string;
}

export enum __ImageSize {
    small = 'small',
    medium = 'medium',
    large = 'large',
}
export interface __WorkSpace {
    created_at: string;
    forms: __Form[];
    creator?: number;
    id: number;
    is_default?: boolean;
    title: string;
    remaining_form_count?: number;
    my_role?: 'creator' | __Roles;
}
export interface __Form {
    id: number;
    description?: string;
    title: string;
    workspace_id: number;
    background_image_file?: __FileAttachment;
    background_color?: string;
    modified_at: string;
    want_answer_notif: boolean;
}

export enum __Roles {
    Admin = 1,
    Publish = 2,
    Report = 4,
    Form = 3,
}
export interface __Tags {
    id: number;
    title: string;
    created_at: string;
    workspace: number;
}

export interface __VersionCheck {
    is_critical: boolean;
    description: string;
    title: string;
    code: number;
    id: number;
    link: string;
}

export interface __Portal {
    id: number;
    logo_file?: __FileAttachment;
    background_image_file?: __FileAttachment;
    background_color?: string;
    title: string;
    description?: string;
    logo_size?: __ImageSize;
    publish_set: {
        uuid: string;
        form: __FormDetail;
    }[];
    column_number?: number;
    // workspace: number;
}

export interface __PortalPublish {
    id: number;
    uuid?: string;
    title: string;
    portal: __Portal;
    // workspace: number;
}
export interface __PortalDetail {
    id: 1;
    uuid: string;
    title: string;
    portal: {
        id: number;
        logo_file?: __FileAttachment;
        background_image_file?: __FileAttachment;
        title: string;
        background_color?: string;
        description?: string;
        column_number: number;
        logo_size?: __ImageSize;
        portal_publish: {
            id: number;
            publish: {
                id: number;
                uuid: string;
                form: __FormDetail;
            };
        }[];
    };
}
export enum __PortalPublishType {
    link = 1,
    kiosk,
}
export enum __PortalPublishStatus {
    active = 1,
    inActive,
}
export enum __PortalStatus {
    active = 1,
    inActive = 2,
}
export interface __AppVersion {
    id: number;
    code: number;
    title: string;
    description: string;
    is_critical: boolean;
    link: string;
}

export enum __FileUploadErrEnum {
    no_workspace_or_user = 'no_workspace_or_user',
    upload_size_limit = 'upload_size_limit',
}

export enum __FileErrorCodeEnum {
    not_allowed_extension = 'not_allowed_extension',
    too_large_file = 'too_large_file',
}

export interface __ImageUploadErrType {
    non_field_errors: { code: __FileUploadErrEnum }[];
    image: { code: __FileErrorCodeEnum }[];
}

export interface __FileUploadErrType {
    non_field_errors: { code: __FileUploadErrEnum }[];
    file: { code: __FileErrorCodeEnum }[];
}
